/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class ProfileService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'ProfileService\' loaded');
    }
}

export { ProfileService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/service/ProfileService.js